import { useNavigate } from 'react-router';

import { BaseButton } from '@shared/components/base';

import { APP_TEXT } from '../constants';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <section className="flex flex-col items-start gap-3">
      <h1 className="text-[23px] font-bold">{APP_TEXT.notFound.title}</h1>
      <p className="text-[13px] text-text-2">{APP_TEXT.notFound.message}</p>
      <BaseButton variant="secondary" icon="pi pi-arrow-left" onClick={() => void navigate('/dashboard')}>
        {APP_TEXT.notFound.backToDashboard}
      </BaseButton>
    </section>
  );
}
